// extracted by mini-css-extract-plugin
export default {"filter":"vessel_filter_filter__YkN6l","Mui-focused":"vessel_filter_Mui-focused__oSKGR","label":"vessel_filter_label__Ie-kz"};